/** */
import {
  ADD_MANY_FLAGS_TO_STORE,
  ADD_ONE_FLAG_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_FLAGS_TO_STORE,
  REM_ONE_FLAG_FROM_STORE
} from '../actions/flag';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_FLAGS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (flags, flag) => ({
            ...flags,
            [flag.id]: flag
          }),
          {}
        )
      };
    case ADD_ONE_FLAG_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (flags, flag) => ({
            ...flags,
            [flag.id]: flag
          }),
          {}
        )
      };
    case LOAD_FLAGS_TO_STORE:
      return {
        ...payload.reduce(
          (flags, flag) => ({
            ...flags,
            [flag.id]: flag
          }),
          {}
        )
      };
    case REM_ONE_FLAG_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
